import { render, staticRenderFns } from "./training-score-report.vue?vue&type=template&id=ff33bf3e"
import script from "./training-score-report.vue?vue&type=script&lang=js"
export * from "./training-score-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports